import { useState } from "react";
import { http, toastApiError } from "../../lib/api";
import { toast } from "../../lib/notify";
import { Save, X, RotateCcw } from "lucide-react";
import AmountInput, { parseTL } from "../AmountInput";

const inp = "px-2 py-1 text-[11px] border border-slate-300 rounded-md bg-white";

export function InstallmentEditor({ loan, inst, onDone, onCancel }) {
  const [due, setDue] = useState(inst.due_date);
  const [amount, setAmount] = useState(String(inst.amount).replace(".", ","));
  const [busy, setBusy] = useState(false);
  const send = async (body, msg) => {
    setBusy(true);
    try { await http.patch(`/bank-loans/${loan.id}/installments/${inst.no}`, body); toast.success(msg); onDone(); }
    catch (e) { toastApiError(e); } finally { setBusy(false); }
  };
  const save = () => {
    const amt = parseTL(amount);
    if (!due) return toast.error("Taksit tarihi girin");
    if (!(amt > 0)) return toast.error("Taksit tutarı sıfırdan büyük olmalı");
    send({ due_date: due, amount: amt }, `${inst.no}. taksit güncellendi — plan yeniden hesaplandı`);
  };
  return (
    <div className="col-span-full flex items-end gap-2 flex-wrap bg-white border border-amber-300 rounded-md px-3 py-2" data-testid={`loan-inst-editor-${loan.id}-${inst.no}`}>
      <span className="text-[11px] font-bold text-slate-700 self-center">{inst.no}. taksit düzenle</span>
      <label className="block"><span className="block text-[10px] uppercase tracking-wide text-slate-500 mb-0.5">Tarih</span>
        <input type="date" value={due} onChange={(e) => setDue(e.target.value)} data-testid={`loan-inst-edit-date-${loan.id}-${inst.no}`} className={inp} /></label>
      <label className="block"><span className="block text-[10px] uppercase tracking-wide text-slate-500 mb-0.5">Tutar</span>
        <AmountInput value={amount} onChange={setAmount} testid={`loan-inst-edit-amount-${loan.id}-${inst.no}`} className={`${inp} w-32 text-right`} /></label>
      <button type="button" disabled={busy} onClick={save} data-testid={`loan-inst-edit-save-${loan.id}-${inst.no}`}
        className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-slate-900 text-white text-[11px] font-semibold hover:bg-slate-800 disabled:opacity-50"><Save className="w-3 h-3" /> Kaydet</button>
      {inst.edited && <button type="button" disabled={busy} onClick={() => send({ reset: true }, `${inst.no}. taksit varsayılana döndü`)} data-testid={`loan-inst-edit-reset-${loan.id}-${inst.no}`}
        className="inline-flex items-center gap-1 px-2 py-1 rounded-md border border-slate-300 bg-white text-[11px] font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50"><RotateCcw className="w-3 h-3" /> Varsayılana dön</button>}
      <button type="button" onClick={onCancel} data-testid={`loan-inst-edit-cancel-${loan.id}-${inst.no}`} className="inline-flex items-center gap-1 px-2 py-1 text-[11px] text-slate-600 hover:text-slate-900"><X className="w-3 h-3" /> Vazgeç</button>
    </div>
  );
}
